module.exports = "/images/icon-logo-w.svg?28852c64994105f80ada3cb78184a904";